export const weekdays = [
  { code: 1, label: 'monday', order: 1},
  { code: 2, label: 'tuesday', order: 2},
  { code: 3, label: 'wednesday', order: 3},
  { code: 4, label: 'thursday', order: 4},
  { code: 5, label: 'friday', order: 5},
  { code: 6, label: 'saturday', order: 6},
  { code: 0, label: 'sunday', order: 7},
];